import {connect} from 'react-redux';
import Page, {ActionProps, OwnProps, StateProps} from './Page';

export default connect<StateProps, ActionProps, OwnProps, AppState>(
	() => ({}),
	{}
)(Page);
